module.exports = __webpack_public_path__ + "img/Chevrolet.cb972a5b.svg";